import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import TablePage from "./pages/TablePage";
// import LeafPage from "./pages/LeafPage";
import "leaflet/dist/leaflet.css";
import MapPage from "./pages/MapPage";
import MapView from "./pages/MapView";
import { useEffect, useState } from "react";
import Login from "./pages/Login/index";
import PotreePointcloud from "./components/PotreePointcloud";
import Leaflet from "./components/Leaflet";
import TestPotree from "./pages/TestPotree";
import CompareMaps from "./pages/CompareMaps";
// import PDF_Viewer from "./pages/PDF_Viewer";
import CesiumOverlay from "./pages/CesiumOverlay";
import CompareSegment from "./pages/CompareSegment";
import ChartState from "./context/ChartState";
import SiteState from "./context/SiteState";
// import Splash from "./components/Splash";
import { ThemeProvider } from "@mui/material";
import theme from "./themes/theme";
import Projects from "./pages/Projects";
import Dashboard from "./pages/Dashboard";
import DashboardState from "./context/DashboardState";
import Home from "./pages/Dashboard/Home";
import ElevationProfile from "./widgets/D3Chart";
import Profile from "./pages/Profile";
import UnAuth from "./guard/UnAuth";
import Auth from "./guard/Auth";

function App() {
    const [navTitle, setNavTitle] = useState("");
    const [cls, setCls] = useState("App");
    // useEffect(()=>{
    //     if(window.location.pathname.includes("cmaps")){
    //         setCls('app')
    //     }else{
    //         setCls('App')
    //     }
    // }, [window.location.pathname])
    return (
        <DashboardState>
            <SiteState>
                <ChartState>
                    <ThemeProvider theme={theme}>
                        <div className={cls}>
                            <BrowserRouter>
                                <Routes>
                                    {/* All guarded routes */}
                                    {/* <Route exact path="/" element={<LeafPage />} /> */}
                                    {/* <Route exact path="/" element={<TablePage />} /> */}
                                    <Route exact path="/" element={<UnAuth component={Login} />} />
                                    <Route
                                        exact
                                        path="/dashboard"
                                        element={<Auth component={Dashboard} cprops={{tabIndex:0}} />}
                                        // element={<Dashboard tabIndex={0} />}
                                    >
                                        <Route index element={<Home />} />
                                        <Route
                                            path="maps/:id"
                                            element={<Auth component={MapPage} cprops={{}} />}
                                            // element={<MapPage/>}
                                        />
                                        <Route
                                            exact
                                            path="cmaps/:id"
                                            // element={
                                            //     <CompareMaps
                                            //         setNavTitle={setNavTitle}
                                            //         navTitle={navTitle}
                                            //     />
                                            //     // <Compare2 />
                                            // }
                                            element={<Auth component={CompareMaps} cprops={{setNavTitle, navTitle}} />}
                                        />
                                        <Route
                                            exact
                                            path="csegments/:id"
                                        //     element={
                                        //     <CompareSegment
                                        //         setNavTitle={setNavTitle}
                                        //         navTitle={navTitle}
                                        //     />
                                        // }
                                            element={<Auth component={CompareSegment} cprops={{setNavTitle, navTitle}} />}
                                        />
                                        <Route
                                            exact
                                            path="maps3d"
                                            // element={
                                            //     <PotreePointcloud />
                                            //     // <Compare2 />
                                            // }
                                            element={<Auth component={PotreePointcloud} cprops={{}} />}
                                        />
                                        <Route
                                            exact
                                            path="profile"
                                            // element={
                                            //     <Profile />
                                            // }
                                            element={<Auth component={Profile} cprops={{}} />}
                                        />
                                    </Route>
                                    {/* <Route
                                        exact
                                        path="/projects"
                                        element={<Projects />}
                                    /> */}
                                    {/* <Route
                                        exact
                                        path="/mapview"
                                        element={
                                            <MapView
                                                setNavTitle={setNavTitle}
                                                navTitle={navTitle}
                                            />
                                        }
                                    /> */}
                                    {/* <Route
                                        exact
                                        path="/maps/:id"
                                        element={
                                            <MapPage
                                                setNavTitle={setNavTitle}
                                                navTitle={navTitle}
                                            />
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/test"
                                        element={
                                            <ElevationProfile
                                            />
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/csegments/:id"
                                        element={
                                            <CompareSegment
                                                setNavTitle={setNavTitle}
                                                navTitle={navTitle}
                                            />
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/maps3d"
                                        element={<PotreePointcloud />}
                                    />
                                    <Route
                                        exact
                                        path="/elevation"
                                        element={
                                            <Leaflet
                                                setNavTitle={setNavTitle}
                                                navTitle={navTitle}
                                            />
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/overlay"
                                        element={
                                            <div>
                                                <CesiumOverlay
                                                    setNavTitle={setNavTitle}
                                                    navTitle={navTitle}
                                                />
                                            </div>
                                        }
                                    />
                                    <Route exact path="/splash" element={<Splash/>} />
                                    <Route
                                        exact
                                        path="/potrees"
                                        element={<TestPotree />}
                                    />
                                    <Route exact path="/pdf" element={<PDF_Viewer />} /> */}
                                </Routes>
                            </BrowserRouter>
                        </div>
                    </ThemeProvider>
                </ChartState>
            </SiteState>
        </DashboardState>
    );
}

export default App;
